import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
import AnimateHeight from 'react-animate-height';
import axios from 'axios';
import PropTypes from 'prop-types';
import { NavbarBrand } from 'reactstrap';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import Desktop from './Desktop';
import Tab from './Tab';
import Mobile from './Mobile';
import classes from './Preview.module.css';
import config from 'helpers/Config';

const TextOnlyTooltip = withStyles({
  tooltip: {
    fontSize: '14px',
  },
})(Tooltip);

class Preview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedView: 'Desktop',
      show: true,
      height: 'auto',
      template: '',
      prevBtnDetails: {
        prev_btn_txt: '',
        prev_btn_url: '',
      },
      previewLink: '',
      closebtn: '',
    };
  }

  componentDidMount() {
    const { history } = this.props;
    axios
      .get('/template', {
        params: {
          slug: new URLSearchParams(history.location.search).get('template'),
        },
      })
      .then((res) => {
        this.setState({
          template: res.data[0].title.rendered,
          prevBtnDetails: res.data[0].prev_btn_details,
          previewLink: res.data[0].preview_link,
          closebtn: res.data[0].prev_bar_close_btn,
        });
      });
  }

  changeView = (view) => {
    this.setState((prevState) => ({
      selectedView: prevState.selectedView === view ? 'Desktop' : view,
    }));
  };

  handleClick = (url) => {
    window.open(url);
  };

  toggle = (closeBehaviour) => {
    const { height, previewLink } = this.state;
    if (closeBehaviour === 'close') {
      window.open(previewLink, '_self');
    } else {
      this.setState((prevState) => ({
        show: !prevState.show,
        height: height === 'auto' ? 0 : 'auto',
      }));
    }
  };

  handleHomeClick = (url) => {
    window.location = url;
  }

  render() {
    const {
      selectedView,
      template,
      prevBtnDetails,
      previewLink,
      show,
      height,
      closebtn,
    } = this.state;
    const { settings } = this.props;

    let mode = <Desktop url={previewLink} />;
    if (selectedView === 'Desktop') {
      mode = <Desktop url={previewLink} height={height} />;
    } else if (selectedView === 'Tab') {
      mode = <Tab url={previewLink} height={height} />;
    } else {
      mode = <Mobile url={previewLink} height={height} />;
    }
    return (
      <div className={classes.main_preview_wrapper}>
        <AnimateHeight duration={500} height={height}>
          <header className={classes.preview_header}>
            <div className={classes.preview_header_wrapper}>
              <div className={classes.mwb_left_content}>
                <NavbarBrand className={classes.header_title}>
                  {settings.header_logo_url !== '' ? (
                    <img
                      alt="dummy"
                      src={settings.prev_page_logo_url}
                      style={{ maxWidth: '130px', maxHeight: '40px' }}
                      onClick={() => this.handleHomeClick(config.url.FRONTEND_URL)}
                      className={classes.navbar_brand_img}
                    />
                  ) : (
                    ''
                  )}
                </NavbarBrand>
                <div className={classes.mwb_telplate_name}>
                  <h4>
                    {settings.prev_template_label_text}
                    {': '}
                    <Link
                      className={classes.template}
                      to="/"
                      onClick={(e) => e.preventDefault()}
                    >
                      {template}
                    </Link>
                  </h4>
                </div>
                <div className={classes.view_change}>
                  <TextOnlyTooltip title="Mobile view" arrow>
                    <NavLink
                      to="/"
                      onClick={(e) => {
                        e.preventDefault();
                        this.changeView('Mobile');
                      }}
                      className={
                        selectedView === 'Mobile' ? 'mwb_view_active' : ''
                      }
                    >
                      <svg viewBox="0 0 24 24">
                        <path d="M16 2H8c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-4 19c-.5 0-1-.5-1-1s.5-1 1-1 1 .5 1 1-.5 1-1 1zm5-3H7V4h10v14z" />
                      </svg>
                    </NavLink>
                  </TextOnlyTooltip>
                  <TextOnlyTooltip title="Tablet view" arrow>
                    <NavLink
                      to="/"
                      onClick={(e) => {
                        e.preventDefault();
                        this.changeView('Tab');
                      }}
                      className={
                        selectedView === 'Tab' ? 'mwb_view_active' : ''
                      }
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        enableBackground="new 0 0 24 24"
                        height="24"
                        viewBox="0 0 24 24"
                        width="24"
                      >
                        <g>
                          <rect fill="none" height="24" width="24" />
                        </g>
                        <path d="M18,0H6C4.34,0,3,1.34,3,3v18c0,1.66,1.34,3,3,3h12c1.66,0,3-1.34,3-3V3C21,1.34,19.66,0,18,0z M14,22h-4v-1h4V22z M19.25,19H4.75V3h14.5V19z" />
                      </svg>
                    </NavLink>
                  </TextOnlyTooltip>
                  <TextOnlyTooltip title="Desktop view" arrow>
                    <NavLink
                      to="/"
                      onClick={(e) => {
                        e.preventDefault();
                        this.changeView('Desktop');
                      }}
                      className={
                        selectedView === 'Desktop' ? 'mwb_view_active' : ''
                      }
                    >
                      <svg viewBox="0 0 24 24">
                        <path
                          id="desktop-lg-ico-a"
                          d="M21 3H3c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 14c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm10-2H2V5c0-.6.4-1 1-1h18c.6 0 1 .4 1 1v10zm-7.2 7H9.2c-.3 0-.6-.3-.5-.7l.8-2.3h5l.8 2.3c.1.4-.1.7-.5.7z"
                        >
                          {' '}
                        </path>
                      </svg>
                    </NavLink>
                  </TextOnlyTooltip>
                </div>
              </div>
              <div className={classes.mwb_right_btn}>
                {prevBtnDetails.prev_btn_url !== '' &&
                prevBtnDetails.prev_btn_url.length > 0 &&
                prevBtnDetails.prev_btn_url[0] !== undefined &&
                prevBtnDetails.prev_btn_txt[0] !== undefined &&
                prevBtnDetails.prev_btn_txt[0] !== '' ? (
                  <button
                    type="button"
                    name="previewbtn0"
                    className="btn btn-demo m-0"
                    onClick={() => {
                      this.handleClick(prevBtnDetails.prev_btn_url[0]);
                    }}
                  >
                    {prevBtnDetails.prev_btn_txt[0]}
                  </button>
                ) : null}

                {prevBtnDetails.prev_btn_url !== '' &&
                prevBtnDetails.prev_btn_url.length > 0 &&
                prevBtnDetails.prev_btn_url[1] !== undefined &&
                prevBtnDetails.prev_btn_txt[1] !== undefined &&
                prevBtnDetails.prev_btn_txt[1] !== '' ? (
                  <button
                    type="button"
                    name="previewbtn1"
                    className="btn btn-editing m-0"
                    onClick={() => {
                      this.handleClick(prevBtnDetails.prev_btn_url[1]);
                    }}
                  >
                    {prevBtnDetails.prev_btn_txt[1]}
                  </button>
                ) : null}
                <button
                  id={classes.head_layout}
                  type="button"
                  name="closepreview"
                  className="btn mwb-bottom-awro m-0"
                  onClick={() => this.toggle(closebtn)}
                >
                  <svg
                    height="20pt"
                    viewBox="0 0 329.26933 329"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g fill="#040303">
                      <path d="m21.339844 329.398438c-5.460938 0-10.925782-2.089844-15.082032-6.25-8.34375-8.339844-8.34375-21.824219 0-30.164063l286.589844-286.59375c8.339844-8.339844 21.824219-8.339844 30.164063 0 8.34375 8.339844 8.34375 21.824219 0 30.164063l-286.589844 286.59375c-4.183594 4.179687-9.621094 6.25-15.082031 6.25zm0 0" />
                      <path d="m307.929688 329.398438c-5.460938 0-10.921876-2.089844-15.082032-6.25l-286.589844-286.59375c-8.34375-8.339844-8.34375-21.824219 0-30.164063 8.339844-8.339844 21.820313-8.339844 30.164063 0l286.589844 286.59375c8.34375 8.339844 8.34375 21.824219 0 30.164063-4.160157 4.179687-9.621094 6.25-15.082031 6.25zm0 0" />
                    </g>
                  </svg>
                </button>
              </div>
            </div>
          </header>
        </AnimateHeight>

        {!show && closebtn !== 'close' ? (
          <button
            id={classes.head_layout}
            type="button"
            name="previewshow"
            className="btn mwb-bottom-awro m-0 closed_svg"
            onClick={() => this.toggle(closebtn)}
          >
            <svg
              height="20pt"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path d="M174.54,508.94,420.1,263.39a10.74,10.74,0,0,0,0-14.75L174.53,3.06a10.43,10.43,0,0,0-14.75,0L92,70.8a10.43,10.43,0,0,0,0,14.75L262.47,256,92,426.46a10.73,10.73,0,0,0,0,14.75l67.75,67.73A10.43,10.43,0,0,0,174.54,508.94Z" />
            </svg>
          </button>
        ) : (
          ''
        )}
        {mode}
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    settings: store.list.settings,
  };
};

Preview.propTypes = {
  history: PropTypes.object,
  settings: PropTypes.object,
};

export default connect(mapStateToProps, null)(Preview);
